import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c303bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "searchWarpper" }
const _hoisted_3 = { class: "searchInput" }
const _hoisted_4 = { class: "ad" }
const _hoisted_5 = { class: "port" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = {
  key: 0,
  class: "notice"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("店铺")
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { style: {"color":"#666"} }
const _hoisted_12 = { class: "popularRecommen" }
const _hoisted_13 = { class: "titleWarper" }
const _hoisted_14 = { class: "tips" }
const _hoisted_15 = { class: "ul-item" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "info" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = {
  key: 0,
  class: "price"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1))
const _hoisted_22 = {
  key: 1,
  class: "price"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1))
const _hoisted_25 = {
  key: 2,
  class: "price"
}
const _hoisted_26 = { class: "address" }
const _hoisted_27 = { class: "banner" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "info" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "price" }
const _hoisted_32 = {
  key: 0,
  class: "num"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_34 = {
  key: 1,
  class: "num"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_36 = {
  key: 2,
  class: "num"
}
const _hoisted_37 = { class: "address" }
const _hoisted_38 = { class: "tags" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_41 = {
  key: 0,
  class: "vip"
}
const _hoisted_42 = { class: "left" }
const _hoisted_43 = { class: "right" }
const _hoisted_44 = { class: "top" }
const _hoisted_45 = {
  key: 0,
  class: "bottom sliver"
}
const _hoisted_46 = {
  key: 1,
  class: "bottom gold"
}
const _hoisted_47 = {
  key: 2,
  class: "bottom crown"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "split" }, null, -1))
const _hoisted_49 = {
  key: 1,
  class: "notify"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入驻获取更多精准求购信息 点击一键入住", -1))
const _hoisted_51 = { class: "btn" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("立即入住")
const _hoisted_53 = { class: "close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanNoticeBar = _resolveComponent("VanNoticeBar")!
  const _component_VanTab = _resolveComponent("VanTab")!
  const _component_VanTabs = _resolveComponent("VanTabs")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_VanCol = _resolveComponent("VanCol")!
  const _component_VanRow = _resolveComponent("VanRow")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPicker = _resolveComponent("VanPicker")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "type",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isSearchTypeShow = !$setup.isSearchTypeShow))
      }, [
        _createElementVNode("span", null, _toDisplayString($setup.searchType.text), 1),
        _createVNode(_component_VanIcon, {
          name: "arrow-down",
          size: "14"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_VanSearch, {
          background: "none",
          modelValue: $setup.searchWord,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchWord) = $event)),
          placeholder: "请输入搜索关键词"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "search",
          onClick: $setup.search
        }, "搜索"),
        _createVNode(_component_VanSwipe, {
          autoplay: 3000,
          "indicator-color": "white"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_VanSwipe, {
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addList, (image) => {
            return (_openBlock(), _createBlock(_component_VanSwipeItem, {
              class: "my-swipe",
              key: image
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VanImage, {
                  src: image.bgImage,
                  alt: "图片",
                  width: "100%",
                  height: "100%",
                  onClick: ($event: any) => ($setup.router.push({name: "SellerShop", query: {id: image.appUrl.id}}))
                }, null, 8, ["src", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/ent.png"),
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push({name:"About",query:{}})))
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/enter.png"),
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push({name:"Register"})))
        }, null, 8, ["src"]),
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/member.png"),
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.router.push({name:"OpenMembership",query:{viprank:3}})))
        }, null, 8, ["src"])
      ])
    ]),
    ($setup.noticeList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_VanNoticeBar, {
            "left-icon": "volume",
            scrollable: false,
            background: "#FFF",
            color: $setup.noticeEnum[$setup.noticeList[$setup.noticeIndex].product].color
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VanSwipe, {
                class: "notice-swipe",
                vertical: "",
                autoplay: 3000,
                touchable: false,
                "show-indicators": false,
                onChange: $setup.noticeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noticeList, (item) => {
                    return (_openBlock(), _createBlock(_component_VanSwipeItem, { class: "noticeItem" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_VanTag, {
                          type: "success",
                          color: $setup.noticeEnum[item.product].color
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["color"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(item.title.first), 1),
                          _createTextVNode(" " + _toDisplayString(item.title.second), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/title.png"),
          height: "19",
          width: "100"
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_VanIcon, {
            name: "fire",
            color: "red"
          }),
          _createElementVNode("span", {
            class: "text",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.jumpToWechatApp({url:"packageA/pages/zhiding/zhiding"})))
          }, "我要置顶推广上热门"),
          _createVNode(_component_VanIcon, {
            name: "arrow",
            color: "red"
          })
        ])
      ]),
      _createVNode($setup["Vue3SeamlessScroll"], {
        class: "list",
        list: $setup.popularRecommenList,
        direction: "left",
        step: 1,
        singleWidth: $setup.seamlessWidth,
        ease: "ease-out"
      }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.popularRecommenList, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "li-item",
                ref_for: true,
                ref: "popularItem",
                onClick: ($event: any) => (_ctx.$router.push({name:"SupplyDetail",query:{id:item.supplyId}}))
              }, [
                _createVNode(_component_VanImage, {
                  src: item.coverUrl,
                  width: "100%",
                  height: "120px",
                  fit: "cover"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1),
                  (item.price)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(_toDisplayString((item.price).toFixed(2)), 1),
                        _hoisted_21
                      ]))
                    : (item.minPrice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(_toDisplayString((item.minPrice).toFixed(2)), 1),
                          _hoisted_24
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, "电议")),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(item.address), 1)
                ])
              ], 8, _hoisted_16))
            }), 256))
          ])
        ]),
        _: 1
      }, 8, ["list", "singleWidth"])
    ]),
    _createVNode(_component_VanTabs, {
      active: $setup.getListData.keyword,
      "onUpdate:active": _cache[6] || (_cache[6] = ($event: any) => (($setup.getListData.keyword) = $event)),
      onChange: $setup.tabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanTab, {
          title: "全部",
          name: ""
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoryList, (item) => {
          return (_openBlock(), _createBlock(_component_VanTab, {
            title: item.name,
            name: item.name
          }, null, 8, ["title", "name"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_VanList, {
      class: "productList",
      loading: $setup.loading,
      "onUpdate:loading": _cache[7] || (_cache[7] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      onLoad: $setup.getHomeListData,
      "immediate-check": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanRow, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_VanCol, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_van_swipe, {
                    class: "my-swipe",
                    autoplay: 2000,
                    "indicator-color": "white"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (image) => {
                        return (_openBlock(), _createBlock(_component_van_swipe_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_VanImage, {
                              src: image.imageUrl,
                              height: "100%"
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 256))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
              return (_openBlock(), _createBlock(_component_VanCol, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "listItem",
                    onClick: ($event: any) => (_ctx.$router.push({name:"SupplyDetail",query:{id:item.id}}))
                  }, [
                    _createVNode(_component_VanImage, {
                      src: item?.photos[0],
                      style: {"width":"14em","height":"14em"}
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_31, [
                        (item.price)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _hoisted_33,
                              _createTextVNode(_toDisplayString(item.price.toFixed(2)), 1),
                              _createElementVNode("span", null, "元/" + _toDisplayString(item.unit), 1)
                            ]))
                          : (item.minPrice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _hoisted_35,
                                _createTextVNode(_toDisplayString(item.minPrice.toFixed(2)), 1),
                                _createElementVNode("span", null, "元/" + _toDisplayString(item.unit), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, "电议")),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(item.address.split('省')[0]), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createVNode(_component_VanTag, {
                          type: "primary",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 2
                        }, 1536), [
                          [_vShow, item.userCertification.hasIdCard]
                        ]),
                        _withDirectives(_createVNode(_component_VanTag, {
                          type: "success",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 2
                        }, 1536), [
                          [_vShow, item.userCertification.hasBusinessLicense]
                        ])
                      ])
                    ]),
                    (item.userCertification.vipRank > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_VanImage, {
                              src: require("@/assets/img/list/tui.png"),
                              width: "100%",
                              height: "100%"
                            }, null, 8, ["src"])
                          ]),
                          _createElementVNode("span", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              (item.userCertification.vipRank==3)
                                ? (_openBlock(), _createBlock(_component_VanImage, {
                                    key: 0,
                                    src: require("@/assets/img/list/s.png"),
                                    width: "100%",
                                    height: "100%"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (item.userCertification.vipRank==6)
                                ? (_openBlock(), _createBlock(_component_VanImage, {
                                    key: 1,
                                    src: require("@/assets/img/list/h.png"),
                                    width: "100%",
                                    height: "100%"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (item.userCertification.vipRank==7)
                                ? (_openBlock(), _createBlock(_component_VanImage, {
                                    key: 2,
                                    src: require("@/assets/img/list/w.png"),
                                    width: "100%",
                                    height: "100%"
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true)
                            ]),
                            (item.userCertification.vipRank==3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(item.information.year) + "年", 1))
                              : _createCommentVNode("", true),
                            (item.userCertification.vipRank==6)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(item.information.year) + "年", 1))
                              : _createCommentVNode("", true),
                            (item.userCertification.vipRank==7)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(item.information.year) + "年", 1))
                              : _createCommentVNode("", true),
                            _hoisted_48
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_28)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "finished"]),
    ($setup.showregister)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_VanButton, {
              round: "",
              block: "",
              size: "small",
              type: "success",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push({name:"Register",query:{returnUrl:"Home"}})))
            }, {
              default: _withCtx(() => [
                _hoisted_52
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_VanImage, {
              src: require("@/assets/img/close.png"),
              width: "20",
              height: "20",
              onClick: $setup.close
            }, null, 8, ["src"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_VanPopup, {
      show: $setup.isSearchTypeShow,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (($setup.isSearchTypeShow) = $event)),
      style: {"width":"100vw","z-index":"999999"},
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanPicker, {
          title: "搜索类型",
          columns: $setup.searchTypes,
          onConfirm: $setup.typeConfirm,
          onCancel: _cache[9] || (_cache[9] = ($event: any) => ($setup.isSearchTypeShow = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}